module.exports = __webpack_public_path__ + "static/img/fdf5a34b.svg";